import { createSlice, current } from "@reduxjs/toolkit";
import { createSelector } from "reselect";
import _ from "lodash";
import { apiCallBegan } from "./api";
import {
  arrayToObject,
  arrayToObjectForMyQuotes,
  convertArrayOfObjectsToId,
  PossibleClientDetailsStatus,
} from "./helperfuncs";

const slice = createSlice({
  name: "mycustomers",
  initialState: {
    gettingMyCustomers: false,
    gettingMyCharge: false,
    gettingMyCustomersFailed: false,
    gettingMyChargeFailed: false,
    gettingCreateChargeSuccess: false,
    gettingMyCustomersSuccess: false,
    isfirstPage: true,
    documents:[],
    alldocuments: [],
    transactions: [],
    alltransactions: [],
    tablebyId: {}
  },
  reducers: {
    // action => action handler
    gettingPaymentSuccess: (mycustomers, action) => {
      mycustomers.selectedPaymentDetails = action.payload;
    },
    gettingDeleteCardSuccess: (mycustomers, action) => {
      mycustomers.selectedCardDetails = action.payload;
    },
    gettingDefaultCardSuccess: (mycustomers, action) => {
      mycustomers.selectedDefaultCard = action.payload;
    },
    gettingCreateChargeSuccess: (mycustomers, action) => {
      mycustomers.selectedCreateCharge = action.payload;
    },
    gettingPaymentInitialized: (mycustomers, action) => {
      mycustomers.gettingMyCustomers = true;
      mycustomers.gettingMyCustomersFailed = false;
      mycustomers.gettingMyCustomersSuccess = false;
    },

    gettingPaymentFailed: (mycustomers, action) => {
      mycustomers.gettingMyCustomers = false;
      mycustomers.gettingMyCustomersFailed = true;
      mycustomers.gettingMyCustomersSuccess = false;
    },
    gettingCustomersInitialized: (mycustomers, action) => {
      mycustomers.gettingMyCustomers = true;
      mycustomers.gettingMyCustomersFailed = false;
      mycustomers.gettingMyCustomersSuccess = false;
    },
    getCustomerDocumentInitialized: (mycustomers, action) => {
        mycustomers.documents = [];
        mycustomers.alldocuments = [];
    },
    getCustomerTransactionInitialized: (mycustomers, action) => {
        mycustomers.transactions = [];
        mycustomers.alltransactions = [];
    },
    getCustomerReminderInitialized: (mycustomers, action) => {
        mycustomers.reminders = [];
        mycustomers.allreminders = [];
        mycustomers.allremindersDetails = [];
    },
    gettingCreateChargeInitialized: (mycustomers, action) => {
      mycustomers.gettingMyCharge = true;
      mycustomers.gettingMyChargeFailed = false;
      mycustomers.gettingCreateChargeSuccess = false;
    },
    gettingChargeFailed: (mycustomers, action) => {
      mycustomers.gettingMyCustomers = false;
      mycustomers.gettingMyChargeFailed = true;
      mycustomers.gettingCreateChargeSuccess = false;
    },
    gettingCustomersFailed: (mycustomers, action) => {
      console.log("FAILED");
      console.log(action)
      mycustomers.gettingMyCustomers = false;
      mycustomers.gettingMyCustomersFailed = true;
      mycustomers.gettingMyCustomersSuccess = false;
    },

    gettingMyCustomersSuccess: (mycustomers, action) => {
      mycustomers.gettingMyCustomers = false;
      mycustomers.gettingMyCustomersFailed = false;
      mycustomers.gettingMyCustomersSuccess = true;
      mycustomers.order = convertArrayOfObjectsToId(
        action.payload.prospectorder,
        "_id"
      );
      mycustomers.table = action.payload.prospectorder;
      mycustomers.tablebyId = arrayToObjectForMyQuotes(action.payload.prospectorder, '_id');
    },

    gettingClientDetailsInitialized: (mycustomers, action) => {
      mycustomers.table[action.payload.prospectid].clientdetails =
        PossibleClientDetailsStatus.loading;
    },
    gettingClientDetailsSuccess: (mycustomers, action) => {
      mycustomers.table[action.payload.extras.prospectid].clientdetails =
        action.payload.response.clientdetails;
    },
    gettingClienteDetailsFailed: (mycustomers, action) => {
      mycustomers.table[action.payload.extras.prospectid].clientdetails =
        PossibleClientDetailsStatus.failed;
    },
    gettingSearchResultsSuccess: (mycustomers, action) => {
      mycustomers.searchedProspectIDs = action.payload;
      if(mycustomers.searchedProspectIDs?.length){
        if(!mycustomers._tablebkup){
          mycustomers._tablebkup = mycustomers.table; 
        }
        mycustomers.table = action.payload;
      }
    },
    gettingAllCardSuccess: (mycustomers, action) => {
      mycustomers.getAllCards = action.payload.cards;
    },
    editCustomerInitialized: (mycustomers, action) => {
        console.log("edit CUSTOMERS INITIALIZED")
    },
    successCustomerEdit: (mycustomers, action) => {
      let {customerid, key, data} = action.payload;
      if(['companyinfo', 'merge'].includes(key) && data && typeof data === 'object'){
        mycustomers.tablebyId[customerid] = {...mycustomers.tablebyId[customerid], ...data}
      }
      else {
        mycustomers.tablebyId[customerid][key] = data;
      }
    },
    successCustomerDocuments: (mycustomers, action) => {
      mycustomers.documents = action.payload;
      mycustomers.alldocuments = action.payload;
    },
    successCustomerReminders: (mycustomers, action) => {
      mycustomers.reminders = action.payload[0];
      mycustomers.allreminders = action.payload[0];
      mycustomers.allremindersDetails = action.payload[1];
    },
    successCustomerTransactions: (mycustomers, action) => {
      mycustomers.transactions = action.payload;
      mycustomers.alltransactions = action.payload;
    },
    handleFilterReminders: (mycustomers, action) => {
      const prospectId = action.payload;
      const keysToFilter = ['reminders', 'documents', 'transactions'];
      keysToFilter.forEach((key) => {
        mycustomers[key] = prospectId
          ? mycustomers[`all${key}`].filter((item) => item.prospectid === prospectId)
          : mycustomers[`all${key}`];
      });
    },
    setFirstPage: (mycustomers, action) => {
      mycustomers.isfirstPage = action.payload;
    }
  },
});

export const {
  gettingDeleteCardSuccess,
  gettingDefaultCardSuccess,
  gettingCreateChargeSuccess,
  gettingPaymentInitialized,
  gettingPaymentSuccess,
  gettingPaymentFailed,
  gettingCustomersInitialized,
  gettingCreateChargeInitialized,
  gettingMyCustomersSuccess,
  gettingCustomersFailed,
  gettingChargeFailed,
  gettingClientDetailsInitialized,
  getCustomerDocumentInitialized,
  getCustomerTransactionInitialized,
  getCustomerReminderInitialized,
  gettingClienteDetailsFailed,
  gettingClientDetailsSuccess,
  gettingSearchResultsSuccess,
  gettingAllCardSuccess,
  editCustomerInitialized,
  successCustomerEdit,
  successCustomerDocuments,
	successCustomerReminders,
  successCustomerTransactions,
  handleFilterReminders,
  relayCustomerReminderChange,
  setFirstPage
} = slice.actions;

export default slice.reducer;

// Action Creators

export const getMyCustomers = () =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/customers/get-my-customers",
    method: "get",
    onStart: gettingCustomersInitialized.type,
    onSuccess: gettingMyCustomersSuccess.type,
    onError: gettingCustomersFailed.type,
  });

export const getMyCustomer = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/customers/get-my-customers?customerid=" + data,
    method: "get",
    onStart: gettingCustomersInitialized.type,
    onSuccess: gettingMyCustomersSuccess.type,
    onError: gettingCustomersFailed.type,
  });

export const getAllDocuments = (data) =>
	apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/customers/get-customer-documents?q=" + data,
    method: "get",
    onStart: getCustomerDocumentInitialized.type,
    onSuccess: successCustomerDocuments.type,
	});

export const getAllReminders = (data) =>
	apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/customers/get-customer-reminders?q=" + data,
    method: "get",
    onStart: getCustomerReminderInitialized.type,
    onSuccess: successCustomerReminders.type,
	});

export const getAllTransactions = (data) =>
  apiCallBegan({
      serviceUrl: process.env.REACT_APP_BASICSERVICE,
      url: "/api/transactions?customerID=" + data,
      method: "get",
      onStart: getCustomerTransactionInitialized.type,
      onSuccess: successCustomerTransactions.type,
  });

export const editCustomerById = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/customers/edit-my-customer",
    method: "post",
    data: data,
    onStart: editCustomerInitialized.type,
    onSuccess: successCustomerEdit.type,
  });

export const allPaymentCard = () =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/payment/retrive-cards",
    method: "get",
    onStart: gettingCustomersInitialized.type,
    onSuccess: gettingAllCardSuccess.type,
    onError: gettingCustomersFailed.type,
  });

export const addPaymentCard = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/payment/add-card",
    method: "post",
    data: data,
    onStart: gettingPaymentInitialized.type,
    onSuccess: gettingPaymentSuccess.type,
    onError: gettingPaymentFailed.type,
  });
export const deletePaymentCard = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/payment/delete-card",
    method: "post",
    data: data,
    onStart: gettingCustomersInitialized.type,
    onSuccess: gettingDeleteCardSuccess.type,
    onError: gettingCustomersFailed.type,
  });
export const defaultPaymentCard = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/payment/add-default-card",
    method: "post",
    data: data,
    onStart: gettingCustomersInitialized.type,
    onSuccess: gettingDefaultCardSuccess.type,
    onError: gettingCustomersFailed.type,
  });
export const createCharge = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/payment/create-charge",
    method: "post",
    data: data,
    onStart: gettingCreateChargeInitialized.type,
    onSuccess: gettingCreateChargeSuccess.type,
    onError: gettingChargeFailed.type,
  });
export const searchProspects = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/prospects/searchprospects?q=" + data,
    method: "get",
    onSuccess: gettingSearchResultsSuccess.type,
  });
export const searchCustomers = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/customers/searchcustomers?q=" + data,
    method: "get",
    onSuccess: gettingSearchResultsSuccess.type,
  });
export const getClientDetailsUsingProspectId = ({ prospectid }) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/prospects/propsectclientdetails",
    method: "post",
    data: { prospectid },
    onStart: gettingClientDetailsInitialized.type,
    onSuccess: gettingClientDetailsSuccess.type,
    onError: gettingClienteDetailsFailed.type,
    considerPayloads: true,
    onStartPayload: { prospectid },
    onSuccessPayload: { prospectid },
    onErrorPayload: { prospectid },
  });

export const updateScratchpad = (data) => 
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/prospects/upsert-scratchpad",
    method: "post",
    data: data,
    onStart: true,
    onSuccess: true,
    onError: true,
  });
export const saveDocument = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "api/customers/upload-document",
    method: "post",
    data: data,
  });


// selectors

export const getGettingMyCustomers = createSelector(
  (state) => state.entities.mycustomers,
  (mycustomers) => mycustomers?.gettingMyCustomers
);

export const getisFirstPage = createSelector(
  (state) => state.entities.mycustomers,
  (mycustomers) => mycustomers.isfirstPage
);
export const getGettingMyCustomersSuccess = createSelector(
  (state) => state.entities.mycustomers,
  (mycustomers) => mycustomers?.gettingMyCustomersSuccess
);

export const getGettingMyCustomersFailed = createSelector(
  (state) => state.entities.mycustomers,
  (mycustomers) => mycustomers.gettingMyCustomersFailed
);

export const getArrayOfCustomersId = createSelector(
  (state) => state.entities.mycustomers,
  (mycustomers) => mycustomers.order
);

export const getSearchedCustomersArray = createSelector(
  (state) => state.entities.mycustomers,
  (mycustomers) => mycustomers.searchedProspectIDs
);
export const getGettingPaymentSuccess = createSelector(
  (state) => state.entities.mycustomers,
  (mycustomers) => mycustomers.selectedPaymentDetails
);
export const deleteCardSuccess = createSelector(
  (state) => state.entities.mycustomers,
  (mycustomers) => mycustomers.selectedCardDetails
);
export const defaultCardSuccess = createSelector(
  (state) => state.entities.mycustomers,
  (mycustomers) => mycustomers.selectedDefaultCard
);
export const createChargeSuccess = createSelector(
  (state) => state.entities.mycustomers,
  (mycustomers) => mycustomers.selectedCreateCharge
);
export const createChargeInitialized = createSelector(
  (state) => state.entities.mycustomers,
  (mycustomers) => mycustomers.gettingCreateChargeInitialized
);
export const createChargeFailed = createSelector(
  (state) => state.entities.mycustomers,
  (mycustomers) => mycustomers.gettingChargeFailed
);
export const getCustomerDocuments = createSelector(
    (state) => state?.entities?.mycustomers,
    (mycustomers) => mycustomers?.documents
);
export const getCustomerTransactions = createSelector(
    (state) => state?.entities?.mycustomers,
    (mycustomers) => mycustomers?.transactions
);
export const getCustomerReminders = createSelector(
	(state) => state?.entities?.mycustomers,
	(mycustomers) => mycustomers?.reminders
);
export const getCustomerRemindersDetails = createSelector(
	(state) => state?.entities?.mycustomers,
	(mycustomers) => mycustomers?.allremindersDetails
);
export const getDefaultCardInitialized = createSelector(
  (state) => state.entities.mycustomers,
  (mycustomers) => mycustomers.gettingMyCustomersSuccess
);
export const getDefaultCardFailed = createSelector(
  (state) => state.entities.mycustomers,
  (mycustomers) => mycustomers.gettingMyCustomersFailed
);
export const getFilteredCustomersIdArray =
  (broker, status, vertical, startdate, enddate, pids) => (state) => {
    var s = [];
    if (state.entities.mycustomers.table) {
      for (const item of state.entities.mycustomers.order) {
        let pros = state.entities.mycustomers.table[item];
        if (pids && !pids.includes(pros.prospectid)) continue;
        if (startdate && pros.lastupdated < startdate) continue;
        if (enddate && pros.lastupdated > enddate) continue;
        if (broker != "" && pros.brokername != broker) continue;
        if (status != "" && pros.status != status) continue;
        if (
          vertical != "" &&
          pros.vertical["en"] != vertical &&
          pros.vertical["fr"] != vertical
        )
          continue;
        s.push(item);
      }
    }
    return s;
  };

export const getCustomers = createSelector(
  (state) => state.entities.mycustomers,
  (mycustomers) => mycustomers
);
export const getCustomersTable = createSelector(
    (state) => state.entities.mycustomers,
    (mycustomers) => mycustomers.table
  );
export const getAllCardsInformation = createSelector(
  (state) => state.entities.mycustomers,
  (mycustomers) => mycustomers.getAllCards
);
export const getBrokers = createSelector(
  (state) => state.entities.mycustomers,
  (mycustomers) => {
    // var s = [];
    // if (mycustomers.order) {
    //   for (const item of mycustomers.order) {
    //     let bname = mycustomers.table[item].brokername;
    //     if (!s.includes(bname)) s.push(bname);
    //   }
    // }
    let s = [...new Set( mycustomers.table?.flatMap(x => x.teammembers.map(t => t.name )) ) ];
    return s;
  }
);

export const getFilteredProspectsIdArray =
  (broker, status, vertical, startdate, enddate, pids, search) => (state) => {
    var s = [];
    if (state.entities.mycustomers.table) {
      for (const pros of state.entities.mycustomers.table) {
        let brokerSearch = pros?.teammembers.map(x => x.name).includes(broker);
        if(search && ( !pros.company.toLowerCase().includes(search.toLowerCase()) && !pros.bms?.toLowerCase()?.includes(search.toLowerCase()) )    ) continue
        if(broker != "" && !pros?.teammembers.map(x => x.name).includes(broker) ) continue
        if (status != "" && ( (status == 'customer' && !pros.isbinded) || (status == 'prospect' && pros.isbinded) )  ) continue;
        if(vertical && !isNaN(vertical) && parseInt(vertical) != parseInt(pros.details?.industryid) ) continue;
        s.push(pros);
      }
    }
    return s;
  };
export const getStatus = createSelector(
  (state) => state.entities.mycustomers,
  (mycustomers) => {
    var s = [];
    if (mycustomers.order) {
      for (const item of mycustomers.order) {
        let sname = mycustomers.table[item].status;
        if (!s.includes(sname)) s.push(sname);
      }
    }
    return s;
  }
);

export const getVertical = createSelector(
  (state) => state.entities.mycustomers,
  (mycustomers) => {
    var s = [];
    if (mycustomers.order) {
      for (const item of mycustomers.order) {
        let bname = mycustomers.table[item].vertical;
        if (!s.includes(bname)) s.push(bname);
      }
    }
    return s;
  }
);

export const getRowDetailsFromCustomerId =
  ({ customerid }) =>
  (state) => {
    //console.log("INSIDE GETROW DETIALS")
    //console.log(state.entities.mycustomers)
    if (state.entities.mycustomers && state.entities.mycustomers.tablebyId)
      return state.entities.mycustomers.tablebyId[customerid];
    return {};
  };


export const getClientDetailStatus =
  ({ customerid }) =>
  (state) =>
    state.entities.mycustomers.table[customerid]
      ? state.entities.mycustomers.table[customerid].clientdetails
      : {};
